import { useEffect, useState } from "react";
import { ArrowLeft } from "@phosphor-icons/react";
import api from "@/lib/api";

const hasToken = () => typeof localStorage !== "undefined" && !!localStorage.getItem("gestaocv_token");

/** Bar for the super-admin reviewing a demo; prospects (no login) never see it. */
export function AdminDemoBar() {
  const [admin, setAdmin] = useState(false);
  useEffect(() => {
    if (!hasToken()) return;
    api.get("/auth/me").then(({ data }) => setAdmin(!!data.is_platform_admin)).catch(() => {});
  }, []);
  if (!admin) return (
    <div className="fixed left-3 top-7 z-[60]">
      <button type="button" onClick={() => (window.history.length > 1 ? window.history.back() : window.location.assign("/"))}
        className="flex items-center gap-1 rounded-full bg-zinc-900/80 px-3 py-1.5 text-xs font-semibold text-white shadow-lg backdrop-blur hover:bg-zinc-900" data-testid="demo-visitor-back">
        <ArrowLeft size={14} /> Voltar
      </button>
    </div>
  );
  return (
    <div className="fixed inset-x-0 top-7 z-[60] flex justify-start px-3" data-testid="admin-demo-bar">
      <a href="/plataforma/prospeccao" className="flex items-center gap-1 rounded-full bg-zinc-900/90 px-3 py-1.5 text-xs font-semibold text-white shadow-lg backdrop-blur hover:bg-zinc-900" data-testid="admin-demo-back">
        <ArrowLeft size={14} /> Voltar à Prospeção
      </a>
    </div>
  );
}
